var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'v-checkbox-group',
    _vm.showError && !!_vm.errorSlot && 'v-checkbox-group--error'
  ]},[_vm._t("default"),_c('div',{class:['v-checkbox-group__helper']},[_vm._v(_vm._s(_vm.showError ? _vm.errorSlot : ""))]),(!_vm.mounted)?_c('div',{ref:"error"},[_vm._t("error")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }